import type { KeyboardEvent } from 'react';
import { RISK_TYPE } from '../proto/trade-copier_pb';

/** Format an optional magic number without treating zero as missing. */
export const formatMagicNumber = (value?: number | null): string => (value == null ? '' : value.toString());

export const RISK_VALUE_ERROR = 'Enter a risk value greater than 0';

// Number inputs still accept sign and exponent keys; a risk value never needs them.
const RISK_INPUT_BLOCKED_KEYS = ['-', '+', 'e', 'E'];

export const blockInvalidRiskKeys = (event: KeyboardEvent): void => {
  if (RISK_INPUT_BLOCKED_KEYS.includes(event.key)) {
    event.preventDefault();
  }
};

export type RiskFields = {
  riskSettings?: unknown;
  riskSettingsFixedLot?: unknown;
  riskSettingsBalancePercentage?: unknown;
};

/** The form field that holds the value for the selected risk type. */
export const activeRiskValue = (riskType: number, fields: RiskFields): unknown => {
  if (riskType === RISK_TYPE.FIXED_LOT) {
    return fields.riskSettingsFixedLot;
  }
  if (riskType === RISK_TYPE.BALANCE_PERCENTAGE) {
    return fields.riskSettingsBalancePercentage;
  }
  return fields.riskSettings;
};

// An invalid number input reports '' which Number() turns into 0, so empty is rejected explicitly.
export const isValidRiskValue = (value: unknown): boolean => {
  if (value === '' || value == null) {
    return false;
  }
  const num = Number(value);
  return Number.isFinite(num) && num > 0;
};
